<div (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (focusout)="onFocusOut($event)">
  <div class="digits-code__cell-container">
    @for (cell of cells(); let i = $index; track i) {
      <fr8bot-ui-input-field
        [value]="cell"
        [disabled]="disabled()"
        [setNoPadding]="true"
        [placeholder]="'0'"
        [isInvalid]="showError()"
        [isErrorVisible]="false"
        [isFocused]="activeIndex() === i"
        (valueChange)="onCellInput(i, $event)"
        (touch)="touch.emit()"
        (focusin)="onFocus(i)"
        class="digits-code__cell"
      />
    }
  </div>
</div>

<div class="digits-code__error-container">
  @if (showError()) {
    <fr8bot-ui-validation-error [error]="error()" class="digits-code__error" />
  }
</div>
